<script setup>
defineProps({
  notification: {
    type: Object,
    required: true
  }
});
</script>

<template>
  <div class="notification-card" :style="{ borderLeftColor: notification.color }">
    <div class="notification-content">
      <font-awesome-icon
        :icon="['fal', notification.icon]"
        class="notification-icon"
        :style="{ color: notification.color }"
      />
      <div class="notification-text">
        <h3>{{ notification.summary }}</h3>
        <p>{{ notification.detail }}</p>
      </div>
    </div>
  </div>
</template>

<style scoped>
.notification-card {
  background-color: #ffffff;
  border-left: 5px solid;
  border-radius: 5px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  margin-bottom: 1rem;
  padding: 1rem;
  width: 25em;
  word-wrap: break-word;
}

.notification-card h3 {
  margin: 0 0 0.5rem 0;
  font-size: 1.1rem;
}

.notification-card p {
  margin: 0;
  font-size: 0.9rem;
  color: #666;
}

.notification-content {
  display: flex;
  align-items: center;
  gap: 1rem;
}

.notification-icon {
  font-size: 1.75rem;
  display: flex;
  justify-content: center;
  min-width: 2rem;
}

.notification-text {
  flex: 1;
}
</style>
